import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css';
import App from './App';
import AuthGate from './components/AuthGate';
import { initAuth } from './services/auth';
import reportWebVitals from './reportWebVitals';

/* local `npm start` only — see devProofSeed.ts; webpack removes this branch in production */
if (process.env.NODE_ENV !== 'production') require('./devProofSeed');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/* Auth must settle BEFORE the first render: returning from Microsoft, the URL
   carries the auth code that handleRedirectPromise() consumes, and the gate has
   to know whether there is an active account. Resolves immediately (and never
   rejects) when the environment has auth disabled. */
initAuth().then(() => {
  root.render(
    <React.StrictMode>
      <AuthGate>
        <App />
      </AuthGate>
    </React.StrictMode>
  );
});

reportWebVitals();
